import { render } from "./ContainerTerminalEventsTable.vue?vue&type=template&id=224c293c&scoped=true&ts=true"
import script from "./ContainerTerminalEventsTable.vue?vue&type=script&lang=ts"
export * from "./ContainerTerminalEventsTable.vue?vue&type=script&lang=ts"

import "./ContainerTerminalEventsTable.vue?vue&type=style&index=0&id=224c293c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224c293c"]])

export default __exports__